const BOOST_CONVERSION_MODAL_SESSION_KEY =
  'boost-conversion-modal-session-id';
const BOOST_CONVERSION_MODAL_SHOWN_KEY =
  'boost-conversion-modal-shown-session-id';

/** Disparado na janela quando o Boost é fechado (`markBoostConversionModalAsShown`). */
export const BOOST_CONVERSION_MODAL_CLOSED_EVENT = 'boost-conversion-modal-closed';

const BOOST_CONVERSION_MODAL_PATHS = ['/dashboard', '/dashboard/sales'];

const isClient = () => typeof window !== 'undefined';

const getSessionStorageValue = (key: string): string | null => {
  if (!isClient()) return null;
  return window.sessionStorage.getItem(key);
};

export const createBoostConversionModalSession = (): void => {
  if (!isClient()) return;

  const sessionId = String(Date.now());
  window.sessionStorage.setItem(BOOST_CONVERSION_MODAL_SESSION_KEY, sessionId);
  window.sessionStorage.removeItem(BOOST_CONVERSION_MODAL_SHOWN_KEY);
};

export const getBoostConversionModalSessionId = (): string | null =>
  getSessionStorageValue(BOOST_CONVERSION_MODAL_SESSION_KEY);

export const markBoostConversionModalAsShown = (): void => {
  if (!isClient()) return;

  const sessionId = getBoostConversionModalSessionId();
  if (!sessionId) return;

  window.sessionStorage.setItem(BOOST_CONVERSION_MODAL_SHOWN_KEY, sessionId);
  // O `sessionStorage` não avisa a própria aba. Quem espera o Boost fechar (o aviso da oferta de
  // antecipação) escuta este evento para tentar abrir de novo.
  window.dispatchEvent(new Event(BOOST_CONVERSION_MODAL_CLOSED_EVENT));
};

export const hasBoostConversionModalBeenShown = (): boolean => {
  if (!isClient()) return false;

  const sessionId = getBoostConversionModalSessionId();
  const shownSessionId = getSessionStorageValue(BOOST_CONVERSION_MODAL_SHOWN_KEY);
  return !!sessionId && sessionId === shownSessionId;
};

/**
 * O Boost abre em `/dashboard` e `/dashboard/sales`, uma vez por login (há sessão e ainda não foi
 * mostrado). Enquanto ele está pendente ou aberto, outro modal não deve subir por cima.
 */
export const isBoostConversionModalPending = (pathname: string): boolean => {
  if (!BOOST_CONVERSION_MODAL_PATHS.includes(pathname)) return false;

  // Sem `sessionStorage` (aba anônima, política do navegador) o Boost também não sabe se já abriu:
  // melhor não esperar por ele do que travar o aviso da oferta.
  try {
    return !!getBoostConversionModalSessionId() && !hasBoostConversionModalBeenShown();
  } catch {
    return false;
  }
};
